import { Col, Container } from "react-grid-system";
import { Link } from "react-router-dom";
import { Button } from "../../components/Button";
import { Unit } from "../../components/Unit";
import ArrowIcon from "../../assets/img/icons/arrow-prev.svg";
import CloseIcon from "../../assets/img/icons/close.svg";
import Bar from "../../components/Bar/Bar";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { useState } from "react";
import { theme } from "../../styles/theme";
import { CloseBtn } from "../../components/CloseBtn";

export default function AddUnitPage() {
	const [isEditMode, setIsEditMode] = useState(false);

	return (
		<>
			{isEditMode ? (
				<>
					<Bar bg={theme.color.blue0} fullWidth infobar={true}>
						<Col>
							<p>Edit mode</p>
						</Col>
						<Col>
							<div className="d-flex justify-content-end">
								<CloseBtn onClick={() => setIsEditMode(false)} icon={CloseIcon} />
							</div>
						</Col>
					</Bar>
				</>
			) : (
				<Bar fullWidth>
					<Link to="/">
						<Button bg={false} small icon={ArrowIcon}>
							Back
						</Button>
					</Link>
					<Breadcrumbs />
				</Bar>
			)}
			<Container>
				<Unit newUnit isEditMode={isEditMode} setIsEditMode={setIsEditMode} />
			</Container>
		</>
	);
}
